var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoxSide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 810,
    height: 190,
    viewBox: "0 0 810 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_187_4671)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 16C31.7452 16 21 26.7452 21 40V96C21 109.255 31.7452 120 45 120H45.0504C45.0375 136.733 45 164 45 164C45 164 53.7398 129.425 75.5483 120H765C778.255 120 789 109.255 789 96V40C789 26.7452 778.255 16 765 16H45Z",
    fill: "url(#paint0_linear_187_4671)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0504 120L45.5504 120L45.5508 119.5H45.0504V120ZM45 164L44.5 163.999L45.4848 164.123L45 164ZM75.5483 120V119.5H75.4449L75.3499 119.541L75.5483 120ZM21.5 40C21.5 27.0213 32.0213 16.5 45 16.5V15.5C31.469 15.5 20.5 26.469 20.5 40H21.5ZM21.5 96V40H20.5V96H21.5ZM45 119.5C32.0213 119.5 21.5 108.979 21.5 96H20.5C20.5 109.531 31.469 120.5 45 120.5V119.5ZM45.0504 119.5H45V120.5H45.0504V119.5ZM44.5504 120C44.544 128.366 44.5314 139.366 44.5204 148.274C44.5149 152.729 44.5098 156.66 44.5061 159.477C44.5042 160.886 44.5027 162.017 44.5016 162.795C44.5011 163.184 44.5007 163.485 44.5004 163.689C44.5003 163.791 44.5002 163.868 44.5001 163.921C44.5001 163.947 44.5 163.966 44.5 163.979C44.5 163.986 44.5 163.991 44.5 163.994C44.5 163.996 44.5 163.997 44.5 163.998C44.5 163.998 44.5 163.999 44.5 163.999C44.5 163.999 44.5 163.999 45 164C45.5 164.001 45.5 164.001 45.5 164C45.5 164 45.5 164 45.5 163.999C45.5 163.999 45.5 163.997 45.5 163.996C45.5 163.992 45.5 163.987 45.5 163.981C45.5 163.968 45.5001 163.948 45.5001 163.922C45.5002 163.87 45.5003 163.792 45.5004 163.69C45.5007 163.487 45.5011 163.186 45.5016 162.796C45.5027 162.018 45.5042 160.888 45.5061 159.479C45.5098 156.661 45.5149 152.73 45.5204 148.276C45.5314 139.367 45.544 128.367 45.5504 120L44.5504 120ZM45 164C45.4848 164.123 45.4848 164.123 45.4848 164.122C45.4848 164.122 45.4849 164.122 45.485 164.121C45.4853 164.121 45.4856 164.119 45.4861 164.117C45.4871 164.113 45.4886 164.107 45.4907 164.099C45.4948 164.083 45.501 164.059 45.5094 164.027C45.5263 163.963 45.5518 163.867 45.586 163.74C45.6546 163.488 45.7582 163.115 45.8981 162.636C46.1778 161.679 46.6021 160.299 47.1794 158.612C48.3343 155.239 50.1001 150.644 52.5432 145.758C57.4409 135.963 65.0103 125.099 75.7466 120.459L75.3499 119.541C64.2777 124.326 56.573 135.462 51.6487 145.311C49.1808 150.247 47.3986 154.885 46.2333 158.288C45.6505 159.991 45.2216 161.385 44.9382 162.356C44.7965 162.841 44.6911 163.22 44.6209 163.478C44.5859 163.608 44.5596 163.707 44.542 163.774C44.5333 163.807 44.5266 163.833 44.5222 163.85C44.52 163.859 44.5183 163.866 44.5171 163.87C44.5165 163.872 44.5161 163.874 44.5158 163.875C44.5156 163.876 44.5155 163.877 44.5154 163.877C44.5153 163.877 44.5152 163.877 45 164ZM765 119.5H75.5483V120.5H765V119.5ZM788.5 96C788.5 108.979 777.979 119.5 765 119.5V120.5C778.531 120.5 789.5 109.531 789.5 96H788.5ZM788.5 40V96H789.5V40H788.5ZM765 16.5C777.979 16.5 788.5 27.0213 788.5 40H789.5C789.5 26.469 778.531 15.5 765 15.5V16.5ZM45 16.5H765V15.5H45V16.5Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_187_4671",
    x: -39.5,
    y: -44.5,
    width: 889,
    height: 268.622,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_187_4671"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.494118 0 0 0 0 0.768627 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_187_4671",
    result: "effect2_dropShadow_187_4671"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_187_4671",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_187_4671",
    x1: 21,
    y1: 92.1707,
    x2: 324.375,
    y2: 471.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E5E5",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF",
    stopOpacity: 0.22
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxSide);
export default __webpack_public_path__ + "static/media/box-side.e847042cc8bd42ea951c34e775646346.svg";
export { ForwardRef as ReactComponent };